/**
 * Vendor Dashboard - Placeholder Component
 * 
 * This component serves as a placeholder for future marketplace functionality.
 * When multi-vendor features are implemented, this will be expanded to include:
 * - Vendor registration
 * - Product management
 * - Order management
 * - Commission tracking
 * - Sales analytics
 */

import { Link } from 'react-router-dom'
import './VendorDashboard.css'

export default function VendorDashboard() {
    return (
        <div className="vendor-dashboard">
            <div className="container">
                <div className="coming-soon">
                    <div className="coming-soon-icon">🏪</div>
                    <h1>Vendor Marketplace</h1>
                    <p className="tagline">Coming Soon</p>
                    <p className="description">
                        We're building an exciting marketplace where vendors can sell their products
                        alongside our company offerings. Stay tuned for updates!
                    </p>

                    <div className="features-preview">
                        <h3>Planned Features</h3>
                        <ul>
                            <li>✓ Easy vendor registration</li>
                            <li>✓ Product listing management</li>
                            <li>✓ Order fulfillment tracking</li>
                            <li>✓ Transparent commission system</li>
                            <li>✓ Sales analytics dashboard</li>
                            <li>✓ Direct customer communication</li>
                        </ul>
                    </div>

                    <Link to="/" className="btn btn-primary btn-lg">
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    )
}
